import React from 'react'
import HeroSlider from '../Components/slider/HeroSlider'
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import ServiceSlider from '../Components/slider/ServiceSlider';
import TestSlider from '../Components/slider/TestSlider';
import LogoSlider from '../Components/slider/LogoSlider';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ProjectSlider from '../Components/slider/ProjectSlider';
import { Helmet } from "react-helmet-async";

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const fadeRight = {
    hidden: { opacity: 0, x: -40 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
};

const fadeLeft = {
    hidden: { opacity: 0, x: 40 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
};

const clients = [
    { img: "/assets/home/item4.svg", title: "150+ Clients", text: "With a strong client base of over 150 organizations, we’ve earned the trust of leading names across industrial, automation, solar, and oil & gas sectors. Our relationships are built on transparency, performance, and a commitment to deliver value that stands the test of time.", link: "/cloud-engineering" },

    { img: "/assets/home/newc1.png", title: "10+ Experienced Staff", text: "Our team of qualified professionals brings deep technical expertise and industry insight to every project. From concept to completion, they ensure each solution is practical, efficient, and aligned with global standards of quality and safety.", link: "/cloud-engineering" },
    { img: "/assets/home/newc5.png", title: "7+ Years of Experience", text: "With over seven years of dedicated service, Al Ibtekar has consistently provided reliable solutions tailored to complex project demands. Our experience enables us to anticipate challenges, innovate with precision, and deliver outcomes that exceed expectations.", link: "/product-services" },
    { img: "/assets/home/newc7.png", title: "100+ Projects Done", text: "We take pride in successfully completing more than 100 diverse projects across various industries. Each project is a reflection of our commitment to engineering excellence, timely execution, and customer satisfaction.", link: "/performance-engineering-services" },
    // { img: "/assets/home/newc2.png", title: "Cloud Services", text: "End-to-end cloud migration, optimization, and management for seamless operations.", link: "/cloud-services" },
    // { img: "/assets/home/newc3.png", title: "DevOps Services", text: "Accelerate delivery with automated, agile, and collaborative DevOps practices.", link: "/devops-services" },
    // { img: "/assets/home/item4.svg", title: "Culture, Values and ESG", text: "Driving growth with integrity, innovation, and sustainable responsibility.",  link: "/consulting-services"  },
    // { img: "/assets/home/newc4.png", title: "ServiceNow Consulting", text: "Transform workflows with expert ServiceNow implementation and consulting.", link: "consulting-services" },
    // { img: "/assets/home/newc6.png", title: "Infor M3 Solutions", text: "Empowering enterprises with tailored Infor M3 ERP solutions and support.", link: "/infor-m3-solution-services" },

]

function Home() {
    const { ref: ref1, inView: inView1 } = useInView({ triggerOnce: true });
    const { ref: ref2, inView: inView2 } = useInView({ triggerOnce: true });
const { ref: expRef, inView: expInView } = useInView({
    triggerOnce: false, // 👈 every time trigger
    threshold: 0.3,
});

    return (
        <>
         <Helmet>
            <title>
                Cable Management & Termination Solutions in UAE | Al Ibtekar
            </title>

            <meta
                name="description"
                content="Al Ibtekar provides cable management, cable termination, junction boxes, electrical enclosures, cable glands, labelling and E&I solutions across the UAE."
            />

            <meta
                name="keywords"
                content="cable management UAE, cable termination UAE, cable management solutions UAE, cable termination company UAE, electrical enclosures UAE, junction boxes UAE, cable glands UAE, cable accessories UAE, E&I solutions UAE, industrial electrical solutions UAE"
            />

            <link
                rel="canonical"
                href="https://saig.me/"
            />

            <meta
                property="og:title"
                content="Cable Management & Termination Solutions in UAE | Al Ibtekar"
            />

            <meta
                property="og:description"
                content="Reliable cable management, cable termination, electrical enclosures, junction boxes, cable glands and E&I solutions from Al Ibtekar, UAE."
            />

            <meta
                property="og:url"
                content="https://saig.me/"
            />

            <meta
                property="og:type"
                content="website"
            />

            <meta
                property="og:site_name"
                content="Al Ibtekar"
            />

            <meta
                name="twitter:card"
                content="summary_large_image"
            />

            <meta
                name="twitter:title"
                content="Cable Management & Termination Solutions in UAE | Al Ibtekar"
            />

            <meta
                name="twitter:description"
                content="Cable management, cable termination, junction boxes, electrical enclosures and E&I solutions across the UAE."
            />
        </Helmet>
            <div className='overflow-hidden hero-slider'>
                <HeroSlider />
            </div>
            <section
                ref={ref1}
                className="lg:pt-[30px] pt-[30px] lg:pb-[60px] pb-[60px] overflow-hidden"
            >
                <div className="flex flex-col lg:flex-row items-center justify-between max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] gap-[60px] lg:gap-0">
                    {/* Left Image */}
                    <div className="relative w-full lg:w-1/2">
                        <img
                            src="/assets/exp.png"
                            alt="Trusted cable management and termination solutions provider in the UAE"
                            className="w-full h-auto object-contain"
                        />
<div ref={expRef} className="absolute bottom-0 lg:left-[186px] left-[40px] max-w-[213px] w-full">
                         <h6 className="font-[500] font-inter lg:text-[65px] text-[46px] lg:leading-[65px] leading-[54px] text-[#FBB210]">
    {expInView && (
        <CountUp
            key={expInView ? 'visible-1' : 'hidden-1'}   // 👈 re-render trick
            start={0}
            end={7}
            duration={5}
        />
    )}+
</h6>

                            <p className="font-[500] font-inter text-[18px] leading-[24px] text-[#0F0F0F]">
                                Years Of Experience
                            </p>
                        </div>

                    </div>

                    {/* Right Content */}
                    <div className="relative w-full lg:w-3/5 max-w-[466px] z-10">
                        <div className="absolute top-[-60px] right-[-20px]">
                            <img
                                src="/assets/home/wrap2.svg"
                                alt="Decorative shape"
                                className="w-[100px] lg:w-[150px] h-auto"
                            />
                        </div>

                        <motion.p
                            variants={fadeRight}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="font-[400] font-kanit text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]"
                        >
                            ABOUT US
                        </motion.p>

                        <motion.h6
                            variants={fadeUp}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="font-[500] font-kanit relative text-[26px] lg:text-[42px] leading-[34px] lg:leading-[50px] tracking-[0.2px] text-[#0F0F0F] max-w-full pb-[15px]"
                        >
                            Innovative Beginnings. Trusted Growth.
                        </motion.h6>

                        <motion.p
                            variants={fadeUp}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="font-[300] font-kanit text-[16px] sm:text-[17px] leading-[26px] sm:leading-[27px] text-[#616161] max-w-full pb-[40px]"
                        >
                            Al Ibtekar began in September 2018 with just a two-member team and a bold mission — to enhance the cable management and termination industry by connecting real challenges with innovative, reliable solutions. A technical partner for cable management & termination and E&I Bulk solutions, we work closely with field engineers and technicians to design and deliver solutions that solve real problems, meet international standards, and ensure technical excellence. Our journey continues through partnerships with niche, innovation-led manufacturers, ensuring we offer products that are certified, safe, and future-ready.
                        </motion.p>

                        <Link to="/about">
                            <motion.button
                                variants={fadeLeft}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] bg-[#FBB210] hover:bg-[#000000] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] rounded-full group transition-all duration-300"
                            >
                                View more
                                <img
                                    src="/assets/nav/arrow.svg"
                                    alt="Arrow icon"
                                    className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-0"
                                />
                            </motion.button>
                        </Link>
                    </div>
                </div>
            </section>

            <section className='service-section overflow-hidden lg:pt-[50px] pt-[50px] lg:pb-[50px] pb-[50px]'>
                <div
                    className="lg:px-[50px] px-[20px] max-w-[1440px] w-full mx-auto lg:pb-[42px] pb-[20px] flex justify-between lg:items-center items-start lg:flex-row flex-col"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    variants={fadeUp}
                >
                    <motion.div
                        variants={fadeRight}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                    >
                        <p className="font-[400] font-kanit text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]">
                            our unique services
                        </p>
                        <h6 className="font-[500] font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] max-w-[324px] w-full pb-[15px]">
                            Our Advanced Tech Services.
                        </h6>
                    </motion.div>

                    <motion.button
                        variants={fadeLeft}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] bg-[#FBB210] hover:bg-[#000000] text-[#FFFFFF] py-[14px] px-[20px] rounded-full group transition-all duration-300 mt-6 lg:mt-0"
                    >
                        View more
                        <img
                            src="/assets/nav/arrow.svg"
                            alt="Industries served by Al Ibtekar: oil & gas, infrastructure, automation, and power"
                            className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
                        />
                    </motion.button>
                </div>
                <div className="pl-[20px] relative service-slider overflow-hidden">
                    <ServiceSlider />
                </div>
            </section>
            <section className='lg:pt-[50px] pt-[60px] pb-[60px]' style={{ background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }}>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <p className="font-[400] font-kanit text-left text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]">Our Success Stories</p>

                    <h6 className="font-[500] text-left font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] lg:pb-[70px] pb-[30px]">
                        Projects Done
                    </h6>
                </div>

                <div className='max-w-[1440px] w-full mx-auto overflow-hidden lg:px-[50px] px-[20px]'>
                    <ProjectSlider />
                </div>
            </section>
            <section className='lg:pt-[50px] pt-[60px] pb-[60px]' style={{ background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }}>
                <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
                    <motion.p
                        className="font-[400] font-kanit text-left text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                    >
                        powerful features
                    </motion.p>
                    <h6 className="font-[500] text-left font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] lg:pb-[50px] pb-[30px]">
                        Our Key Features
                    </h6>
                    <div className='border-t-[2px] border-[#49577A66] flex flex-wrap lg:gap-[30px] gap-0 lg:justify-center'>
                        <div className='lg:pt-[40px] pt-[20px]'>
                            <img src="/assets/service/icon1.svg" alt="Al Ibtekar technical support team offering on-site cable solution consulting" />
                            <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">Certified Product Range</h6>
                            <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">All our solutions meet industry standards for safety, durability, and performance.</p>
                        </div>
                        <div className="line1"></div>
                        <div className='lg:pt-[40px] pt-[20px]'>
                            <img src="/assets/service/icon2.svg" alt="Al Ibtekar technical support team offering on-site cable solution consulting" />
                            <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">Tailored Technical Solutions</h6>
                            <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">Customised enclosures, labelling, and termination to comply with the project specifications.</p>
                        </div>
                        <div className="line2"></div>
                        <div className='lg:pt-[40px] pt-[20px]'>
                            <img src="/assets/service/icon3.svg" alt="Al Ibtekar technical support team offering on-site cable solution consulting" />
                            <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">Field-Tested Reliability</h6>
                            <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">Built for real-world use — trusted by professionals in demanding environments.</p>
                        </div>
                        <div className="line3"></div>
                        <div className='lg:pt-[40px] pt-[20px]'>
                            <img src="/assets/service/icon4.svg" alt="Al Ibtekar team delivering certified cable products and electrical solutions" />
                            <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">End-to-End Expertise</h6>
                            <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">From product sourcing to on-site integration, we deliver complete support.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section ref={ref2} className='bg-[#FBB210] lg:pt-[196px] pt-[60px] lg:pb-[144px] pb-[60px] overflow-hidden'>
                <div className="flex items-center justify-between lg:flex-row flex-col max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <div>
                        <motion.p
                            className="font-[400] font-kanit text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FFFFFF] pb-[20px]"
                            variants={fadeUp}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            Why choose us
                        </motion.p>

                        <motion.h6
                            className="font-[500] max-w-[604px] w-full font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#FFFFFF] pb-[10px]"
                            variants={fadeUp}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ delay: 0.2 }}
                        >
                            Trusted Solutions. Tailored Excellence.
                        </motion.h6>
                        <p className="max-w-[498px] w-full py-[10px] pb-[40px] font-[300] font-kanit text-[17px] leading-[27px] text-[#FFFFFF]">At Al Ibtekar, we go beyond... across industrial, automation, solar and oil & gas sectors</p>
                        <div className="grid grid-cols-2 gap-x-[80px] gap-y-[40px]">
                            <div>
                                <h6 className="font-[500] font-inter text-[28px] leading-[32px] tracking-[0.6px] text-[#FFFFFF] pb-[14px]">
                                    {inView2 && <CountUp end={150} duration={2} />}+
                                </h6>
                                <p className="font-[500] font-inter text-[18px] leading-[30px] tracking-[0.5px] text-[#FFFFFF]">Clients</p>
                            </div>

                            <div>
                                <h6 className="font-[500] font-inter text-[28px] leading-[32px] tracking-[0.6px] text-[#FFFFFF] pb-[14px]">
                                    {inView2 && <CountUp end={10} duration={2} />}+
                                </h6>
                                <p className="font-[500] font-inter text-[18px] leading-[30px] tracking-[0.5px] text-[#FFFFFF]">Experienced Staff</p>
                            </div>

                            <div>
                                <h6 className="font-[500] font-inter text-[28px] leading-[32px] tracking-[0.6px] text-[#FFFFFF] pb-[14px]">
                                    {inView2 && <CountUp end={7} duration={2} />}+
                                </h6>
                                <p className="font-[500] font-inter text-[18px] leading-[30px] tracking-[0.5px] text-[#FFFFFF]">Years Of Experience</p>
                            </div>

                            <div>
                                <h6 className="font-[500] font-inter text-[28px] leading-[32px] tracking-[0.6px] text-[#FFFFFF] pb-[14px]">
                                    {inView2 && <CountUp end={100} duration={2} />}+
                                </h6>
                                <p className="font-[500] font-inter text-[18px] leading-[30px] tracking-[0.5px] text-[#FFFFFF]">Projects Done</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <img style={{width:'600px' , height:'500px',objectFit:'cover',borderRadius:'20px'}} src="/assets/home/whynew.jpg" alt="Al Ibtekar team delivering certified cable products and electrical solutions" />
                    </div>
                </div>
            </section> */}

            <section className="bg-[#FFFFFF] py-[60px] md:py-[50px]">
                <div className="max-w-[1440px] flex flex-col lg:flex-row justify-between items-start mx-auto w-full gap-[40px] lg:px-[50px] px-[20px]">
                    <div className="lg:max-w-[480px] max-w-[100%] w-full text-[#000000] lg:sticky lg:top-[150px] self-start">
                        <h6 data-aos="fade-right" className="text-[28px] lg:text-[48px] font-outfit font-[400] mb-[24px] leading-[40px] lg:leading-[56px]">
                            Why choose us
                        </h6>
                        <p className="font-outfit text-[16px] font-[400] leading-[24px] mb-[20px] md:mb-[36px]">
                            Trusted Solutions. Tailored Excellence.
                            At Al Ibtekar, we go beyond... across industrial, automation, solar and oil & gas sectors
                        </p>
                        <div className="group inline-flex items-center h-[50px] cursor-pointer  rounded-[10px] px-[20px]">
                            <i className="bi bi-arrow-right text-[#000] mt-[-5px] text-[40px] leading-[40px] transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                        </div>

                    </div>
                    <div className="lg:max-w-[600px] max-w-[100%] w-full">
                        <div className="grid gap-[20px]">
                            {clients.map((item, index) => (
                                <div key={index}>
                                    <div
                                        className="nsr border group relative rounded-[8px] backdrop-blur-[10px] p-[15px] md:p-[20px] pr-[60px] md:pr-[74px] transition-all duration-300 transform hover:scale-[1.03] hover:shadow-lg hover:bg-[#FBB210] hover:text-white"
                                        style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}
                                    >
                                        <div className="flex flex-col sm:flex-row gap-[15px] md:gap-[30px] items-start">
                                            <div className="text-[#000] dark:text-[#000000] group-hover:text-white transition-colors duration-300">
                                                <h6 className="text-[20px] font-outfit md:text-[24px] lg:text-[26px] font-[500] mb-[15px] md:mb-[25px] transition-colors duration-300">
                                                    {item.title}
                                                </h6>
                                                <p className="text-[14px] font-outfit font-[400] leading-[20px] transition-colors duration-300">
                                                    {item.text}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section>


            <section className="overflow-hidden pt-[5px]" style={{ background: `radial-gradient(101.52% 172.9% at 90% 80%, rgba(228, 74, 26, 0.15) 0%, rgba(228, 74, 26, 0) 20%), radial-gradient(88.64% 150.96% at 20% 35%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }}>
                <div className="our-test lg:px-[50px] px-[20px] max-w-[1440px] w-full mx-auto">
                    <motion.p
                        className="font-[400] font-kanit text-left text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                    >
                        Testimonials
                    </motion.p>

                    <motion.h6
                        className="font-[500] text-left font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] pb-[80px]"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ delay: 0.2 }}
                    >
                        What our clients say about us
                    </motion.h6>
                    <div className="test-slider">
                        <TestSlider />
                    </div>
                </div>
                <div className='overflow-hidden lg:py-[106px] py-[40px]'>
                    <LogoSlider />
                </div>
            </section>
            {/* <section className='lg:pt-[115px] pt-[60px] pb-[60px] lg:px-[75px] px-[20px]' style={{ background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }}>
                <motion.p
                    className="font-[400] font-kanit text-center text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]"
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                >
                    Accredited & Trusted
                </motion.p>
                <h6 className="font-[500] text-center font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] lg:pb-[30px] pb-[30px]">
                   Certified for Quality & Excellence
                </h6>
                <div className='Certified-logos'>
                    
                    <img src="/assets/certify logo (3).png" alt="Al Ibtekar ISO 9001:2015 certification for quality management systems" />
                    <img src="/assets/certify logo (1).png" alt="Al Ibtekar ISO 9001:2015 certification for quality management systems" />
                    <img src="/assets/certify logo (2).png" alt="Al Ibtekar ISO 9001:2015 certification for quality management systems" />
                    <img src="/assets/certify logo (4).png" alt="Al Ibtekar ISO 9001:2015 certification for quality management systems" />
                </div>
            
            </section> */}
        </>
    )
}

export default Home